import React from 'react';
import styled from 'styled-components';
import { useQuery } from '@apollo/client';
import { useParams } from 'react-router-dom';
import { MANDANT_BY_REGISTERID } from '../AuthenticationPage/MandantRegisterHeadline';
import AuthenticationPage from '../AuthenticationPage/AuthenticationPage';
import Box from '../../styledComponents/Box';
import LinkButton from '../../styledComponents/LinkButton';
import warningIcon from '../../assets/warning.png';
import logo from '../../assets/logo.png';

const StyledGrid = styled.div`
  height: 100vh;
  display: grid;
  grid-template-columns: auto auto auto;
  justify-content: center;
  align-items: center;
`;

const StyledContent = styled(Box)`
  align-items: center;
  display: flex;
  flex-direction: column;
  margin-left: 10px;
  margin-right: 10px;
  padding-bottom: 30px;
  padding-left: 10px;
  padding-top: 30px;
  padding-right: 10px;

  @media (min-width: 600px) {
    padding-left: 40px;
    padding-right: 40px;
    width: 450px;
    max-width: 450px;
  }
`;

const RegisterAtMandant = () => {
  const { mandantRegisterId } = useParams();
  const { loading, data } = useQuery(MANDANT_BY_REGISTERID, {
    variables: { mandantRegisterId },
    // fetchPolicy: 'network-only',
  });

  // console.log({ loading, data, error });

  if (loading) {
    return null;
  }

  if (data?.mandantByRegisterId) {
    return <AuthenticationPage />;
  }

  return (
    <StyledGrid>
      <div />
      <StyledContent>
        <div>
          <img src={logo} alt='Kursifant Logo' />
        </div>
        <div>
          <img src={warningIcon} alt='Warnung' />
        </div>
        <br />
        <div>
          <b>Das hat leider nicht geklappt!</b>
        </div>
        <br />
        <div>
          Es scheint, als wäre der Link nicht korrekt. Unter dieser Kennung
          konnte kein Kursanbieter gefunden werden. Gehe bitte auf Deinen
          Trainingsanbieter zu und lasse Dir den richtigen Link geben.
        </div>
        <br />
        <div>
          Klicke{' '}
          <LinkButton
            onClick={() => {
              window.location.replace('/');
            }}>
            hier
          </LinkButton>{' '}
          , um zum Login zu gelangen.
        </div>
        <br />
        <div>
          Kommst Du gar nicht weiter, schreibe mir gern an{' '}
          <a href='mailto:kimberly@kursifant.com'>kimberly@kursifant.com</a>-
          dann helfe ich Dir.
        </div>
      </StyledContent>
      <div />
    </StyledGrid>
  );
};

export default RegisterAtMandant;
